import "jQuery";
import 'waypoints/lib/jquery.waypoints.min';
// import 'waypoints/lib/shortcuts/inview.min';
import 'jquery.counterup';

'use strict';

(function($) {

    $(document).ready(function() {
        $('body').css('opacity', 1);
        if($.fn.counterUp) {
            $('.animated-number').counterUp({
                delay: 10,
                time: 1000
            });
        }

        $("*[class^='has-animation-'],*[class*=' has-animation-']").waypoint(function() {
            let $elmt = $(this.element);
            $elmt.addClass('animated');
            if($elmt.hasClass('has-animation-fadeInLeft')) {
                $elmt.addClass('fadeInLeftShort');
            } else if($elmt.hasClass('has-animation-fadeInRight')) {
                $elmt.addClass('fadeInRightShort');
            } else if($elmt.hasClass('has-animation-fadeInDown')) {
                $elmt.addClass('fadeInDownShort');
            } else if($elmt.hasClass('has-animation-fadeInUp')) {
                $elmt.addClass('fadeInUpShort');
            }
        }, { offset: '80%'});

    });

    $(document).on('click', 'a[href^="#"]:not(.no-scroll):not([data-toggle=collapse])', function (e) {
        let offset = 0;
        if($(this).data('offset') !== undefined) {
            offset = $(this).data('offset');
        }
        var href = $.attr(this, 'href');
        if(href.length > 1) {
            var $target = $($.attr(this, 'href'));
            if($target.data('offset') !== undefined && offset === 0) {
                offset = $target.data('offset');
            }
            if($target.length > 0) {
                $('body').addClass('auto-scrolling');
                e.preventDefault();
                $('html, body').stop().animate({
                    scrollTop: $target.offset().top - offset
                }, 500, function() {
                    $('body').removeClass('auto-scrolling');
                });
            }
        }
    });
})( jQuery );